import { PropsWithChildren, ReactNode, useMemo } from 'react';

import { getRoutesDirections } from '@/data/libraries/Routes';

import { NavLink, useLocation } from 'react-router-dom';
import type { Location } from 'react-router-dom';

import { Col, Container, Row } from 'react-bootstrap';

import { translate } from '@/domain/utils/translate';

import IconList from '@/ui/components/IconList';
import ManagementListTitle from '@/ui/containers/managementOptions/ManagementListTitle';
import { useSelector } from 'react-redux';
import { RootState } from '@/ui/store/store';

interface PropsManagementList {
  /** Propiedad que define si viene o no con subtitulos */
  subtitles?: boolean;
  /** Evento que maneja el modal */
  handleModal?: (params: any) => ReactNode | void;
}

/** Componente List Usuario Administrativo
 * @component
 */
const ManagementList = ({ handleModal, subtitles = true }: PropsWithChildren<PropsManagementList>): JSX.Element => {
  /**  Hook para trabajar con document location  */
  const location: Location = useLocation();

  /** Seleccionamos el idioma desde Redux */
  const language = useSelector((state: RootState) => state.language.language);
  /** Recalculamos las rutas cuando cambia el idioma */
  const routesDirections = useMemo(() => getRoutesDirections(language), [language]);

  return (
    <Container id='management-list' fluid className='p-0'>
      <Row className='g-0 align-items-center'>
        <Col xs={12} className='svg-primary-2'>
          <ManagementListTitle />
        </Col>
        <ul className='w-100 list-unstyled svg-secondary-1'>
          <li>
            <NavLink
              to={routesDirections.INVENTORY_ROUTE}
              className={({ isActive }) => (isActive ? 'active' : '')}
              state={{ originURL: location.pathname }}>
              <IconList
                classIcon='pe-2'
                classTitle=' fw-bold'
                iconName='ico-inventory'
                classMain='my-1 px-2 align-items-center btn-list-description-icon-light w-100 '
                title={translate("management_list.inventory_label")}
                subtitle={subtitles ? translate("management_list.inventory_description") : null}
                onClick={handleModal}
              />
            </NavLink>
          </li>
          <li>
            <NavLink
              to={routesDirections.SALES_HISTORY_ROUTE}
              className={({ isActive }) => (isActive ? 'active' : '')}
              state={{ originURL: location.pathname }}>
              <IconList
                classIcon='pe-2'
                classTitle=' fw-bold'
                iconName='ico-sales'
                classMain='my-1 px-2 btn-list-description-icon-light align-items-center  w-100'
                title={translate("management_list.sales_label")}
                subtitle={subtitles ? translate("management_list.sales_description") : null}
                onClick={handleModal}
              />
            </NavLink>
          </li>
          {/* <IconList
                iconName='ico-store'
                classMain='my-1 px-2 btn-list-description-icon-light'
                title={translate("management_list.offices_label")}
                subtitle={
                  subtitles
                    ? translate("management_list.offices_description")
                    : null
                }
              /> */}
        </ul>
      </Row>
    </Container>
  );
};

export default ManagementList;
